import { createFileRoute } from '@tanstack/react-router'

import { TeamDetailPage } from '@/features/teams/TeamDetailPage'

export const Route = createFileRoute('/_app/teams/$teamId')({
  component: TeamDetailRouteComponent,
})

function TeamDetailRouteComponent() {
  const { teamId } = Route.useParams()
  const parsed = Number(teamId)
  return <TeamDetailPage teamId={Number.isFinite(parsed) ? parsed : NaN} />
}
